import Alert from '@mui/material/Alert';
import { SpaceType } from '@onesource/schemas';
import { useGetSpace, useGetSubSpaces } from '@onesource/services';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { SpaceHomePage } from '../../../../../features/community-hub/components/space-home-page';
import { SpaceHomePageSkeleton } from '../../../../../features/community-hub/components/space-home-page-skeleton';
import { usePreviewMode } from '../../../../../features/community-hub/hooks/use-preview-mode';

export const Route = createFileRoute('/_protected/community-hub/spaces/$id/')({
  component: SpaceHomeRoute,
});

function SpaceHomeRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { isPreview } = usePreviewMode();
  const { data: space, isLoading: isLoadingSpace, error: spaceError } = useGetSpace(id);
  const { data: subSpaces, isLoading: isLoadingSubSpaces } = useGetSubSpaces(id, { preview: isPreview });

  const isSingleLesson = space?.spaceType === SpaceType.SINGLE_LESSON;

  useEffect(() => {
    if (isSingleLesson) {
      navigate({ to: `/community-hub/spaces/${id}/lesson`, replace: true });
    }
  }, [isSingleLesson, id, navigate]);

  const modules = subSpaces?.filter(s => s.spaceType === SpaceType.CONTENT) || [];

  if (isLoadingSpace || isLoadingSubSpaces || isSingleLesson) {
    return <SpaceHomePageSkeleton />;
  }

  if (spaceError) {
    return <Alert severity="error">Failed to load space: {spaceError.message}</Alert>;
  }

  if (!space) {
    return <Alert severity="error">Space not found</Alert>;
  }

  return <SpaceHomePage space={space} modules={modules} />;
}
